/* eslint class-methods-use-this: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, DropdownButton, MenuItem, Row, Col, Glyphicon } from 'react-bootstrap';
import _ from 'underscore';
import moment from 'moment';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import { withTranslation } from 'react-i18next';
const cancelReasons = [
    { value: 'Duplicate', localizationSlug: 'DUPLICATE' },
    { value: 'Re-Schedule', localizationSlug: 'RESCHEDULE' },
    { value: 'Customer Mistake', localizationSlug: 'CUSTOMER_MISTAKE' },
    { value: 'Customer Request', localizationSlug: 'CUSTOMER_REQUEST' },
];
class CancelOrderModal extends Component {
    constructor(props) {
        super(props);
        this.handleCancelOrder = () => {
            OrdersActionCreators.cancelOrder(this.props.order._id, this.state.reason);
            this.setState({ reason: null }, () => {
                this.props.onHide();
            });
        };
        this.state = {
            reason: null,
        };
    }
    renderCancelButton() {
        const { t } = this.props;
        return (React.createElement(DropdownButton, { title: this.state.reason || t("CANCELLATION_REASON"), id: "cancel-bg-nested-dropdown" }, cancelReasons.map((reason, i) => (React.createElement(MenuItem, { key: reason.value, eventKey: reason.value, onSelect: key => this.setState({ reason: key }) }, t(reason === null || reason === void 0 ? void 0 : reason.localizationSlug))))));
    }
    render() {
        var _a, _b;
        if (!this.props.order)
            return null;
        const { t } = this.props;
        return (React.createElement(Modal, { show: this.props.show, onHide: () => this.props.onHide(), enforceFocus: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, t('CANCEL_ORDER_WITH_ORDER_ID', { orderId: (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.order) === null || _b === void 0 ? void 0 : _b.order_id }))),
            React.createElement(Modal.Body, null,
                React.createElement(Row, { style: { marginBottom: 10 } },
                    React.createElement(Col, { xs: 12 }, t('CANCEL_ORDER_NOTE'))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 }, this.renderCancelButton()))),
            React.createElement(Modal.Footer, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 8 }),
                    React.createElement(Col, { xs: 4 },
                        React.createElement(Button, { disabled: !this.state.reason, onClick: this.handleCancelOrder, style: {
                                marginRight: '5',
                                fontSize: '.875rem',
                                fontWeight: '700',
                                borderRadius: '.25rem',
                            }, bsStyle: "danger" }, t('CANCEL_ORDER')))))));
    }
}
export default withTranslation()(CancelOrderModal);
